import React, { useState, useEffect, useCallback } from "react";
import { Button, Container, Nav, Row, Col } from "react-bootstrap";
import AboutUs from "./component/AboutUs";
import PrivacyPolicy from "./component/PrivacyPolicy";
import TermsAndConditions from "./component/TermsAndConditions";
import RefundPolicy from "./component/RefundPolicy";
import { get, updateToken } from "../../../helpers/api_helper";
import { useSelector } from "react-redux";

const ContentPage = () => {
  const token = useSelector((state) => state.login.token);
  const [contentData, setContentData] = useState({
    aboutUs: { id: "", content: "", name: "ABOUT_US" },
    privacyPolicy: { id: "", content: "", name: "PRIVACY_POLICY" },
    termsConditions: { id: "", content: "", name: "TERMS_CONDITIONS" },
    refundPolicy: { id: "", content: "", name: "REFUND_POLICY" },
  });
  const [activeTab, setActiveTab] = useState("aboutUs");

  const pageNames = {
    aboutUs: "ABOUT_US",
    privacyPolicy: "PRIVACY_POLICY",
    termsConditions: "TERMS_CONDITIONS",
    refundPolicy: "REFUND_POLICY"
  };

  const fetchContent = useCallback(async (name) => {
    try {
      const response = await get(`/pages/name/${name}`);
      if (response.success) {
        const item = response.data;
        setContentData((prevData) => ({
          ...prevData,
          [activeTab]: {
            id: item._id,
            content: item.content || "",
            name: item.name,
          },
        }));
      } else {
        console.log(response.message || "Failed to fetch content");
      }
    } catch (error) {
      console.log(error);
    }
  }, [activeTab]);

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchContent(pageNames[activeTab]);
    }
  }, [token, fetchContent, activeTab]);

  const handleUpdateContent = (key, newContent) => {
    setContentData((prevData) => ({
      ...prevData,
      [key]: {
        ...prevData[key],
        content: newContent,
      },
    }));
  };

  return (
    <Container>
      <h5 className="my-2 fw-sbold">Content Management</h5>
      <Row>
        <Col lg="12">
          <div className="commonTable scrollable-table-container">
            <div
              className="top px-3 pt-2 d-flex align-items-center justify-content-between gap-10"
              style={{ background: "#F5F7FA" }}
            >
              <Nav variant="pills" className="transparentBtn-Tab py-2 gap-10">
                <Nav.Item>
                  <Nav.Link
                    eventKey="aboutUs"
                    className={`p-0 bg-transparent px-2 ${activeTab === "aboutUs" ? "active" : ""}`}
                    onClick={() => setActiveTab("aboutUs")}
                  >
                    About Us
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="privacyPolicy"
                    className={`p-0 bg-transparent px-2 ${activeTab === "privacyPolicy" ? "active" : ""}`}
                    onClick={() => setActiveTab("privacyPolicy")}
                  >
                    Privacy Policy
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="termsConditions"
                    className={`p-0 bg-transparent px-2 ${activeTab === "termsConditions" ? "active" : ""}`}
                    onClick={() => setActiveTab("termsConditions")}
                  >
                    Terms and Conditions
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    eventKey="refundPolicy"
                    className={`p-0 bg-transparent px-2 ${activeTab === "refundPolicy" ? "active" : ""}`}
                    onClick={() => setActiveTab("refundPolicy")}
                  >
                    Refund Policy
                  </Nav.Link>
                </Nav.Item>
              </Nav>
            </div>
            <div className="content-area px-3 py-2">
              {activeTab === "aboutUs" && (
                <AboutUs
                  content={contentData.aboutUs.content}
                  onUpdate={(data) => handleUpdateContent("aboutUs", data)}
                  pageId={contentData?.aboutUs?.id}
                  pageName={contentData?.aboutUs?.name}
                />
              )}
              {activeTab === "privacyPolicy" && (
                <PrivacyPolicy
                  content={contentData.privacyPolicy.content}
                  onUpdate={(data) => handleUpdateContent("privacyPolicy", data)}
                  pageId={contentData?.privacyPolicy?.id}
                  pageName={contentData?.privacyPolicy?.name}
                />
              )}
              {activeTab === "termsConditions" && (
                <TermsAndConditions
                  content={contentData.termsConditions.content}
                  onUpdate={(data) => handleUpdateContent("termsConditions", data)}
                  pageId={contentData?.termsConditions?.id}
                  pageName={contentData?.termsConditions?.name}
                />
              )}
              {activeTab === "refundPolicy" && (
                <RefundPolicy
                  content={contentData.refundPolicy.content}
                  onUpdate={(data) => handleUpdateContent("refundPolicy", data)}
                  pageId={contentData?.refundPolicy?.id}
                  pageName={contentData?.refundPolicy?.name}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ContentPage;
